import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import { pure } from "recompose";
import { CerrarIcon } from "../../theme/assets";
import classnames from "classnames";
import styles from "./Modal.scss";
import styled from "styled-components";

const ModalContainer = styled(ReactModal)`
  max-width: ${props => (props.modalWidth ? props.modalWidth : "500px")};
`;

ReactModal.setAppElement(document.getElementById("content"));

class Modal extends Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.renderModalContent = this.renderModalContent.bind(this);
    this.toggleAppContent = this.toggleAppContent.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpen !== prevProps.isOpen &&
      this.props.isOpen &&
      this.props.options &&
      this.props.options.mobileMode
    ) {
      const appModal = document.querySelector(".payNoPainForm .appModal");

      if (appModal) {
        setTimeout(() => {
          appModal.style.height = window.innerHeight - 2 + "px";
        }, 300);
      }

      this.toggleAppContent("none");
    }
    if (
      this.props.isOpen !== prevProps.isOpen &&
      !this.props.isOpen &&
      this.props.options &&
      this.props.options.mobileMode
    ) {
      this.toggleAppContent("block");
    }
  }

  handleClose(event, shouldCloseOnEsc) {
    if (shouldCloseOnEsc === false && event.type === "keydown" && event.keyCode === 27) {
      return;
    }

    this.toggleAppContent("block");
    this.props.closeModal();
  }

  toggleAppContent(display) {
    if (this.props.iframeMode) {
      return;
    }
    const appContent = document.getElementById("content");
    if (appContent) {
      appContent.style.display = display;
    }
    // Hack to fix fixed scrolling elements
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop += 1;
      document.scrollingElement.scrollTop -= 1;
    } else if (document.body) {
      document.body.scrollTop += 1;
      document.body.scrollTop -= 1;
    }
  }

  renderModalContent(props) {
    if (document && window) {
      const isMobileMode = (props.options && props.options.mobileMode) || window.innerWidth < 768;

      return (
        <ModalContainer
          ref="modal"
          className={classnames(
            "wbkv9-Modal-modalContainer",
            styles.modal,
            isMobileMode && "wbkv9-Modal-mobileMode",
            isMobileMode && styles.mobileMode,
            props.options && props.options.className
          )}
          overlayClassName={classnames("wbkv9-Modal-modalOverlay", props.className)}
          style={props.style}
          isOpen={props.isOpen}
          shouldCloseOnOverlayClick={
            props.shouldCloseOnOverlayClick === undefined ? true : props.shouldCloseOnOverlayClick
          }
          onRequestClose={event => this.handleClose(event, props.shouldCloseOnEsc)}
          closeTimeoutMS={400}
          modalWidth={props.options && props.options.modalWidth}>
          <div className={classnames("wbkv9-Modal-modalContent", styles.modalContent)}>
            <div className={classnames("wbkv9-Modal-modalInner", styles[`${props.innerClass}`])}>
              {props.showChildrenOverCloseButton && props.children}
              {!props.hideCloseButton && !(props.options && props.options.hideCloseButton) && (
                <div
                  className={classnames(
                    "wbkv9-Modal-modalCloseButton",
                    styles[`${props.closeButtonContainerClass}`]
                  )}>
                  <div
                    className={classnames(
                      "wbkv9-Modal-modalDeleteIcon",
                      styles[`${props.closeButtonClass}`]
                    )}
                    onClick={this.handleClose}>
                    <CerrarIcon />
                  </div>
                </div>
              )}
              {!props.showChildrenOverCloseButton && props.children}
            </div>
          </div>
        </ModalContainer>
      );
    }
    return null;
  }

  render() {
    const { props, renderModalContent } = this;
    const style = (props.options && props.options.styles) || {};
    const mergedProps = { ...props, style };

    return (
      <div
        id="modi"
        className={classnames("wbkv9-Modal", styles.container, props.over && styles.over)}>
        {renderModalContent(mergedProps)}
      </div>
    );
  }
}

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  iframeMode: PropTypes.bool,
  closeModal: PropTypes.func,
  showChildrenOverCloseButton: PropTypes.bool,
};

Modal.defaultProps = {
  innerClass: "inner",
  closeButtonContainerClass: "closeButton",
  closeButtonClass: "deleteIcon",
  showChildrenOverCloseButton: false,
};

export default pure(Modal);
